import { swalErrorMessage } from "../../../../Constant/swalMessage";
import {
  addCustomerService,
  deleteCusomerService,
  editCustomerService,
  getAllCustomersService,
} from "../../services/customers.services";
import { customerType } from "./customers.type";

export const getAllCustomersAction = (params) => async (dispatch) => {
  const res = await getAllCustomersService(params);
  if (res) {
    await dispatch({
      type: customerType.GET_CUSTOMERS_LIST,
      payload: res?.data,
    });
    return res?.data;
  }
};

export const addCustomerAction = (obj) => async () => {
  const res = await addCustomerService(obj);
  if (res.status === 200) {
    return res.status;
  } else {
    swalErrorMessage(res.errMsg);
  }
};

export const editCustomerAction = (id, obj) => async () => {
  const res = await editCustomerService(id, obj);
  if (res.status === 200) {
    return res.status;
  } else {
    swalErrorMessage(res.errMsg);
  }
};

export const deleteCusomerAction = (id) => async () => {
  const res = await deleteCusomerService(id);
  if (res.status === 200) {
    return res.status;
  } else {
    swalErrorMessage(res.errMsg);
  }
};
